import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { uploadData } from 'aws-amplify/storage';
import { UserManagementService } from '../../../shared/services/user-management.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  @Input() title: string = 'Select processed file to upload on S3 bucket';
  @Input() parent?: string;
  @Output() uploadCompleted = new EventEmitter<boolean>();

  allowedExtensions: string[] = ['.csv'];
  uploading = false;
  fileList: NzUploadFile[] = [];
  progressRatio = 0;
  isLoading = false;

  constructor(
    private nzMessageService: NzMessageService,
    private userManagementService: UserManagementService,
  ) {}

  privateUpload(): void {
    this.fileUpload('private');
  }

  fileUpload(access: 'private' | 'public'): void {
    if (!this.fileList.every((file) => this.validateFile(file))) {
      return;
    }
    const formData = new FormData();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const apis$ = this.fileList.map((file: any) => {
      formData.append('files[]', file);
      this.uploading = true;
      this.isLoading = true;

      const stageBucket = this.userManagementService.getBucketName();
      const identityId = this.userManagementService.userDetails.identityId;
      const s3Key = `${access}/${identityId}/${file.name}`;

      return uploadData({
        path: s3Key,
        data: file,
        options: {
          bucket: {
            bucketName: stageBucket,
            region: 'us-east-1',
          },
          onProgress: (progress: any) => {
            this.progressRatio = Math.round((progress.loaded / progress.total) * 100);
          },
        },
      }).result;
    });

    Promise.all(apis$)
      .then(() => {
        this.uploading = false;
        this.isLoading = false;
        this.fileList = [];
        this.progressRatio = 0;
        this.uploadCompleted.emit(true);
        this.nzMessageService.success('File(s) uploaded successfully.');
      })
      .catch((err) => {
        this.uploading = false;
        this.nzMessageService.error(`File(s) upload failed with error ${err}`);
      });
  }

  handleUpload() {
    this.privateUpload();
  }

  /**
   * Method to concat the file for upload before uploading to S3
   */
  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.concat(file);
    return false;
  };

  /**
   * Method to validated uploaded files are from allowed file list
   */
  validateFile(file: NzUploadFile): boolean {
    const validFileTypes = [...this.allowedExtensions, 'text/csv'];
    const fileExtension = file.name.split('.')[1];
    if (!validFileTypes.includes(file.type || `.${fileExtension}`)) {
      this.nzMessageService.error(`${file.name} file is not valid, please select valid CSV file`);
      setTimeout(() => (this.isLoading = false), 200);
      return false;
    }
    return true;
  }
}
